<template>
  <div>
    <b-row>
      <b-col md="12" class="hide-label">
        <InputTextArea
          class="mb-4"
          type="text"
          textFloat="Text"
          placeholder=""
          name="text"
          rows="5"
          v-model="response.content.Text"
          :isValidate="v.content.Text.$error"
          :v="v.content.Text"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputTextArea from "@/components/inputs/InputTextArea";
export default {
  components: {
    InputTextArea
  },
  props: {
    response: {
      required: true,
      type: Object
    },
    v: {
      required: true,
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped></style>
